"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _AbstractRatingRenderer = _interopRequireDefault(require("./AbstractRatingRenderer"));

var _UIAbstractRatingInput = _interopRequireDefault(require("UIComponents/input/abstract/UIAbstractRatingInput"));

var _RatingTypes = require("../../constants/reviews/RatingTypes");

var AbstractRating = function AbstractRating(props) {
  var rating = props.rating,
      label = props.label,
      labelSize = props.labelSize,
      direction = props.direction,
      height = props.height,
      justify = props.justify,
      use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["rating", "label", "labelSize", "direction", "height", "justify", "use"]);
  var flexAlignment = direction === 'row' ? 'center' : 'start';
  var renderedLabel = (0, _react.useMemo)(function () {
    if (!label) {
      return null;
    }

    var labelClassName = direction === 'row' ? 'm-left-3' : 'm-top-1';

    if (use === 'card') {
      return _react.default.createElement(_Small.default, {
        className: "m-left-2",
        use: "help",
        style: {
          whiteSpace: 'nowrap'
        }
      }, label);
    }

    return _react.default.createElement("span", {
      style: {
        fontSize: _RatingTypes.LabelSizesTemplate[labelSize],
        whiteSpace: 'nowrap'
      },
      className: (0, _classnames.default)('rating-label', labelClassName)
    }, label);
  }, [label, labelSize, use, direction]);
  return _react.default.createElement(_UIFlex.default, {
    direction: direction,
    align: flexAlignment,
    justify: justify,
    style: {
      height: height
    }
  }, _react.default.createElement(_UIAbstractRatingInput.default, (0, _extends2.default)({
    Component: _AbstractRatingRenderer.default,
    defaultValue: rating,
    showPercentage: true
  }, rest)), renderedLabel);
};

AbstractRating.propTypes = (0, _extends2.default)({}, _UIAbstractRatingInput.default.propTypes, {
  showPercentage: _propTypes.default.bool,
  rating: _propTypes.default.number.isRequired,
  label: _propTypes.default.node,
  labelSize: _propTypes.default.string,
  direction: _propTypes.default.string,
  justify: _propTypes.default.string,
  use: _propTypes.default.oneOf(['card', 'default'])
});
AbstractRating.defaultProps = {
  rating: 3,
  labelSize: 'small',
  direction: 'row',
  use: 'default'
};
var _default = AbstractRating;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/reviews/AbstractRating.js
// module id = 608
// module chunks = 209 210 211 212